export const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'https://checktech.app';

export const landingPath = (path = '') => `${LANDING_URL}${path}`;
